<div class="container" *ngIf="!OrderPlaced">
  <ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
    [spinner]="spinkit.skThreeBounce">
  </ng-http-loader>
  <div *ngIf="!OrderPlaced">
    <div class="row" style="padding-top: 24px;">
      <button (click)="backClicked()" style="border: none;background: transparent;margin-top: -5px;"><img
          src="../../../../assets/img/Icon ionic-ios-arrow-back.svg" alt=""></button>
      <div class="card-title">Your Cart</div>
    </div>
    <div>
      <div class="ml-5">
        <div class="tableclass">Table No : {{tableID}}</div>
      </div>

      <div class="addMore">
        <div><a (click)="goToMenu()">+Add more</a> </div>
      </div>

    </div>

    <div *ngIf="!hideTable" style="max-height: 70vh;overflow-y: scroll;overflow-x: hidden;">
      <div *ngFor="let items of orderItem;let i = index">
        <div class="d-flex justify-content-between mt-3" style="margin-left: 25px;">
          <div>
            <div class="cartname " style="text-transform:capitalize ;">{{items.Name}}</div>
            <div *ngIf="items.option_price">
              <div class="opt_name">{{items.option_name}} <span class="opt_price">£ {{items.option_price}}</span></div>
            </div>
            <div *ngIf="!items.option_price">
              <div class="mt-2 addon_prices">£ {{value_coupon(items.originalPrice)}}</div>
            </div>
          </div>
          <!-- <div>
            <div class="wrapper">
              <button class="plusminus-left" *ngIf="(conditionToDisaply &&getQuantity(items.food_dish_id,i)>0)"
                (click)="removeFromCart(items.food_dish_id)">-</button>
              <button class="plusminusgrey"
                *ngIf="!(conditionToDisaply &&getQuantity(items.food_dish_id,i)>0)">-</button>
              <span class="addmenu" *ngIf="!(conditionToDisaply && getQuantity(items.food_dish_id,i)>0)">Add</span>
              <label class="addmenu"
                *ngIf="(conditionToDisaply &&getQuantity(items.food_dish_id,i)>0)">{{getQuantity(items.food_dish_id,i)}}</label>
              <button class="plusminus"
                (click)="addToCart(i,items.food_dish_id,items.Name,items.price,items.price);addToCartDone(i,getQuantity(items.food_dish_id,i))">+</button>
            </div>
          </div> -->
          <div>
            <div class="wrapper">
              <button class="plusminus-left" *ngIf="(conditionToDisaply &&getQuantity(items.food_dish_id,i)>0)"
                (click)="removeFromCart(items , i)">-</button>
              <label class="addmenu"
                *ngIf="(conditionToDisaply &&getQuantity(items.food_dish_id,i)>0)">{{getQuantity(items.food_dish_id,i)}}</label>
              <button class="plusminus"
                (click)="addToCart(i,items.food_dish_id,items.Name,items.price,items.price);addToCartDone(i,getQuantity(items.food_dish_id,i))">+</button>
            </div>
          </div>
        </div>

        <div *ngIf="items.rdaoop?.length > 0">
          <div style="display: flex;justify-content:space-between;margin-bottom:-15px">
            <div class="opt_name" style="margin-left:15%;margin-top: 3%;">Add ons <img
                src="../../../../assets/img/editIcon.png" alt="" style="margin-left: 8px; cursor: pointer;" (click)="editAddOns(items,i)" ></div>
            <!-- <div>
              <div class="wrapper">
                <button class="plusminus-left" *ngIf="(conditionToDisaply &&getQuantity(items.food_dish_id,i)>0)"
                  (click)="removeFromCart(items.food_dish_id)">-</button>
                <button class="plusminusgrey"
                  *ngIf="!(conditionToDisaply &&getQuantity(items.food_dish_id,i)>0)">-</button>
                <span class="addmenu" *ngIf="!(conditionToDisaply && getQuantity(items.food_dish_id,i)>0)">Add</span>
                <label class="addmenu"
                  *ngIf="(conditionToDisaply &&getQuantity(items.food_dish_id,i)>0)">{{getQuantity(items.food_dish_id,i)}}</label>
                <button class="plusminus" (click)="checkAddon(i,items)">+</button>
              </div>
            </div> -->
          </div>
          <br>
          <div *ngFor="let value of items.rdaoop;let i = index">
            <div>
              <div style="margin-left:12%">
                <div class="d-flex">
                  <div class="addon_Name col-5" (click)="testFunc(value,items)">{{value.addonName}} </div>
                  <div class="col-3 addon_prices">£ {{value.addonPrice}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3 line">
      <div>
        <div class=" col-12">
          <p class="paymentDetails">
            Payment Details
          </p>
        </div>
        <div class="d-flex  mt-2">
          <div class="itemtotal mt-2 col-9">Item total</div>
          <div class="mt-2 col-3" style="margin-left: 17px;"><span class="cartprice">£
              {{value_coupon(totalPriceAfterAddition)}}</span></div>
        </div>
        <hr>
        <div class="d-flex  mt-2">
          <div class="amount col-9 mt-2">Amount Payable</div>
          <div class="mt-2 col-3" style="margin-left: 17px;"><span class="cartprice">£
              {{value_coupon(totalPriceAfterAddition)}}</span></div>
        </div>
      </div>

      <div *ngIf="UserCondition">
        <div class="d-flex" style="justify-content:space-evenly;margin-top: 10px; ">
          <div class="d-flex">
            <div>
              <mat-radio-button color="primary" style="padding-left: 10px" value="paynow"
                (click)="checkPaymentOptions()">
                Pay Now
              </mat-radio-button>
            </div>
          </div>

          <div class="d-flex">
            <div>
              <mat-radio-button color="primary" style="padding-left: 10px" (click)="goToPlaceOrders()">
                Pay after you eat
              </mat-radio-button>
            </div>
          </div>
        </div>

        <div *ngIf="showPaymentOptions">
          <!-- <div style="margin-left: 15%;">
            <mat-radio-button color="primary" value="paynow" (click)="gotoYottaPay()">
              Using Express Pay
            </mat-radio-button>
          </div> -->

          <div style="margin-left: 15%;">
            <mat-radio-button color="primary" value="paynow" (click)="gotoPayments()">
              Using Credit/Debit cards
            </mat-radio-button>
          </div>
        </div>

        <div *ngIf="showBtnForCashPayment" class="d-flex justify-content-center" style="margin-top:50px;">
          <button class="placeorder-btn" (click)="placeOrder()">Place Order</button>
        </div>
      </div>
    </div>
  </div>

  <div align="center" style="margin-top: 18%;" *ngIf=" hideTable">
    <img src="../../../../assets/img/empty_cart.png" style="width: 70%;">
    <p class="empty_cart_p">Good food is always cooking</p><br>
    <p class="empty_text">You cart is empty.</p> <br>
    <p class="empty_text empty_text_top">Add Something from the menu</p>
  </div>
</div>

<div class="container-fluid">
  <!-- <div *ngIf="UserCondition && !OrderPlaced">
    <app-bottommenu></app-bottommenu>
  </div> -->

  <div *ngIf="UserCondition && !OrderPlaced">
    <div class="d-flex justify-content-between">
      <div *ngIf="UserCondition">
        <ul class=" nav nav-pills d-flex justify-content-between">
          <li class="nav-item col-xs-3">
            <a [routerLink]="['../', 'food-menu']" routerLinkActive="active" class="nav-link" #rla="routerLinkActive">
              <img [src]="rla.isActive ? iconmenu : iconAtvmenu" alt="menu" />
              <span class="nav__text">Menu</span>
            </a>
          </li>
          <li class="nav-item col-xs-3">
            <a [routerLink]="['../', 'order-menu']" routerLinkActive="active" class="nav-link"
              #rlas="routerLinkActive"><span class="lengthsSpan" *ngIf="lengths > 0">{{lengths}}</span>
              <img [src]="rlas.isActive ? iconcart : iconAtvcart" alt="">
              <span class="nav__text">Cart</span>
            </a>
          </li>

          <li class="nav-item col-xs-3">
            <a [routerLink]="['../',  'myOrders']" routerLinkActive="active" class="nav-link" #rlag="routerLinkActive">
              <img [src]="rlag.isActive ? iconorder : iconAtvorder" alt="">

              <span class="nav__text">Orders</span>
            </a>
          </li>

          <li class="nav-item col-xs-3 py-1">
            <a [routerLink]="['../', 'profile']" routerLinkActive="active" class="nav-link" #rlap="routerLinkActive">
              <img [src]="rlap.isActive  ? iconprofile : iconAtvprofile " alt="">
              <span class="nav__text">Profile</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <div *ngIf="!UserCondition">
        <ul class=" nav nav-pills d-flex justify-content-between">
          <li class="nav-item col-xs-3">
            <a [routerLink]="['../', 'food-menu-guest']" routerLinkActive="active" class="nav-link"
              #rla="routerLinkActive">
              <img [src]="rla.isActive ? iconmenu : iconAtvmenu" alt="menu" />
              <span class="nav__text">Menu</span>
            </a>
          </li>
          <li class="nav-item col-xs-3">
            <a (click)="getLoginScreen()" routerLinkActive="active" class="nav-link" #rlas="routerLinkActive"><span
                class="lengthsSpan" *ngIf="lengths > 0">{{lengths}}</span>
              <img [src]="rlas.isActive ? iconcart : iconAtvcart" alt="">
              <span class="nav__text">Cart</span>
            </a>
          </li>
          <li class="nav-item col-xs-3">
            <a [routerLink]="['../',  'myOrders']" routerLinkActive="active" class="nav-link" #rlag="routerLinkActive">
              <img [src]="rlag.isActive ? iconorder : iconAtvorder" alt="">

              <span class="nav__text">Orders</span>
            </a>
          </li>
          <li class="nav-item col-xs-3 py-1">
            <a (click)="getLoginScreen()" routerLinkActive="active" class="nav-link" #rlap="routerLinkActive">
              <img [src]="rlap.isActive  ? iconprofile : iconAtvprofile " alt="">
              <span class="nav__text">Profile</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div *ngIf="OrderPlaced">
  <div class="container-fluid">
    <div class="row" style="padding-top: 15px;padding-bottom: 10px; background: #FCFCFC;">
      <img src="/assets/img/backMenu.svg" alt="" (click)="goToMenu()" style="margin-left: 3%;cursor: pointer;"> <span
        class="order-title">Order Completed</span> <span><img src="../../../../assets/img/succes.png" width="26px"
          style="margin-left: 10px;" alt=""></span>
    </div>
  </div>

  <div class="container-fluid">
    <div style="background: #F2F5F7;margin-top: 7%;">
      <div class="billdetails">
        Bill Details
      </div>
    </div>
  </div>

  <div class="container">
    <div class="" style="margin-top: 15px;">
      <div class="restoNamenew">{{restoName}}</div>
      <div class="ordNo">Order No : #{{orderDetailsorderId}} </div>
    </div>

    <div class="" style="margin-top: 15px;">
      <div *ngFor="let orditems of OrderDetails;let i = index">
        <div *ngIf="orditems.order_item_option.length >= 1">
          <div>
            <div class="itemsNamePA">{{i+1}}. {{orditems.dish_name}}</div>
            <div class="d-flex justify-content-between">
              <div *ngFor="let addons of orditems.order_item_option" style="margin-left: 14px;">
                <div class="addonVariantTitle">Variant: <span class="addonOptionName">{{addons.option_name}}</span>
                </div>
              </div>
              <div *ngFor="let addons of orditems.order_item_option">
                <div class="itemsNamePA">£ {{value_coupon(orditems.order_item_single_price) }}</div>
              </div>
            </div>

            <div>
              <div *ngFor="let addons of orditems.order_item_addOn" style="margin-left: 14px;"
                class="d-flex justify-content-between">
                <div class="addonVariantTitle">Add Ons: <span class="addonOptionName">{{addons.addon_name}}</span>
                </div>
                <div class="itemsNamePA">£ {{value_coupon(addons.addon_option_price) }}</div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="orditems.order_item_option.length == 0">
          <div class="d-flex justify-content-between" style="margin-top: 10px;">
            <div class="itemsNamePA">{{i+1}}. {{orditems.dish_name}} <span style="margin-left: 15px;">
                x{{orditems.quantity}}</span></div>
            <div class="itemsNamePA">£ {{value_coupon(orditems.order_item_single_price * orditems.quantity ) }}</div>
          </div>
        </div>
      </div>
      <div style="border-bottom:1px dashed gray;margin-top: 10px;"></div>
    </div>

    <div class="">
      <div class="d-flex justify-content-between" style="margin-top: 10px;">
        <div class="totalItemPA">Item total</div>
        <div class="totalItemPA">£ {{value_coupon(totalPriceAfterAddition)}}</div>
      </div>
      <hr style="width: 100%;margin-top: 10px;">
    </div>

    <div class="">
      <div class="d-flex justify-content-between" style="margin-top: 10px;">
        <div class="itemsNamePA">Amount Paid</div>
        <div class="itemsNamePA">£ {{value_coupon(totalPriceAfterAddition)}}</div>
      </div>
    </div>
  </div>
</div>